import { createValidationSchema, PosixDate, uuidField, } from "@for-it/domain-lib";
import { TenantEntity, TenantStatus, } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const suspendTenant = {
    name: "suspendTenant",
    description: "Sets tenant.status to 'suspended'",
    type: "command",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        id: uuidField({
            required: true,
            message: "Debe ingresar un ID válido",
        }),
    }),
    useCase: async ({ db }, { id }) => {
        const tenant = await db.findOne(TenantEntity, { where: { id } });
        if (!tenant)
            return new TenantNotFoundError();
        const updated = {
            ...tenant,
            status: TenantStatus.SUSPENDED,
            updatedAt: new PosixDate(Date.now()),
        };
        await db.save(TenantEntity, updated);
        return updated;
    },
};
